import { render, staticRenderFns } from "./FuelConsumptionPage.vue?vue&type=template&id=5254be2a&scoped=true&"
import script from "./FuelConsumptionPage.vue?vue&type=script&lang=js&"
export * from "./FuelConsumptionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5254be2a",
  null
  
)

export default component.exports